module.exports = __webpack_public_path__ + "static/media/book-cover.83dd169c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Book/book-cover.png
// module id = 287
// module chunks = 0